let audioContext = null;
let unlockListenersAdded = false;
let lastPlayedAtMs = 0;

const nowMs = () => (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now());

const getOrCreateAudioContext = () => {
  if (audioContext) return audioContext;
  if (typeof window === 'undefined') return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  audioContext = new Ctx();
  return audioContext;
};

const tryResume = async () => {
  const ctx = getOrCreateAudioContext();
  if (!ctx) return false;
  if (ctx.state === 'running') return true;
  try {
    await ctx.resume();
    return ctx.state === 'running';
  } catch {
    return false;
  }
};

export const ensureNotificationSoundUnlocked = () => {
  if (unlockListenersAdded) return;
  unlockListenersAdded = true;
  if (typeof window === 'undefined') return;

  const unlock = async () => {
    try {
      await tryResume();
    } finally {
      window.removeEventListener('click', unlock, true);
      window.removeEventListener('keydown', unlock, true);
      window.removeEventListener('touchstart', unlock, true);
    }
  };

  window.addEventListener('click', unlock, true);
  window.addEventListener('keydown', unlock, true);
  window.addEventListener('touchstart', unlock, true);
};

export const playNotificationBell = async () => {
  const throttleMs = 900;
  const t = nowMs();
  if (t - lastPlayedAtMs < throttleMs) return;
  lastPlayedAtMs = t;

  const ok = await tryResume();
  if (!ok) return;

  const ctx = getOrCreateAudioContext();
  if (!ctx) return;

  try {
    const response = await fetch('/notification.wav');
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer);

    const source = ctx.createBufferSource();
    const gainNode = ctx.createGain();
    gainNode.gain.setValueAtTime(1.0, ctx.currentTime);

    source.buffer = audioBuffer;
    source.connect(gainNode);
    gainNode.connect(ctx.destination);
    source.start();
  } catch (e) {
    console.warn('Notification sound failed:', e);
  }
};

export const playSystemNotificationSound = async () => {
  const throttleMs = 700;
  const t = nowMs();
  if (t - lastPlayedAtMs < throttleMs) return;
  lastPlayedAtMs = t;

  const ok = await tryResume();
  if (!ok) return;

  const ctx = getOrCreateAudioContext();
  if (!ctx) return;

  try {
    const response = await fetch('/system-notification.wav');
    const arrayBuffer = await response.arrayBuffer();
    const audioBuffer = await ctx.decodeAudioData(arrayBuffer);

    const source = ctx.createBufferSource();
    const gainNode = ctx.createGain();
    gainNode.gain.setValueAtTime(1.0, ctx.currentTime);

    source.buffer = audioBuffer;
    source.connect(gainNode);
    gainNode.connect(ctx.destination);
    source.start();
  } catch (e) {
    console.warn('System notification sound failed:', e);
  }
};

